import { render, staticRenderFns } from "./AppointmentManagement.vue?vue&type=template&id=fb9f6286"
import script from "./AppointmentManagement.vue?vue&type=script&lang=js"
export * from "./AppointmentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports